import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";
const { persistAtom } = recoilPersist();

export const ACT = atom({
  key: "AccessToken",
  default: "",
  effects_UNSTABLE: [persistAtom],
});
